import { createAPI } from '@common'
export default {
  // 获取区划树
  getRegionTreeData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0usff', 'GET', config),
  // 全部租户
  getTenantList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tfmfdujpo0hfuUfobouMjtu', 'GET', config),
  //云端稿库-选用记录 选用稿件时并再次编辑页面时-新增选用记录
  postsSelectionAdd: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tfmfdujpo0bee', 'POST', config),
  //云端稿库-选用记录 选用稿件列表
  postsSelectionGetList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tfmfdujpo0hfuMjtu', 'POST', config),
  //云端稿库-选用记录 导出选用记录列表
  postsSelectionExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tfmfdujpo0fyqpsu', 'POST', config),
  // 获取稿件来源模块列表
  getModuleList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tfmfdujpo0hfuNpevmfMjtu', 'GET', config),
  // 获取下载文件size
  getFilePartSize: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmf0qbsu0tj{f', 'GET', config),
  // // 获取下载文件
  getFilePartDownloadByPath: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0gjmf0qbsu0epxompbeCzQbui', 'POST', config),
  // 获取导出文件列表
  getSelectionRecordData: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0f60mjtuebub', 'post', config, vconfig),
  // 删除导出记录
  postsSelectionDelete: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0tfmfdujpo0efmfuf', 'POST', config)
}
